import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import BaseFNOLWizard from './BaseFNOLWizard';
import VehicleDamagePicker from './components/VehicleCollision/VehicleDamagePicker';
import Address from './models/Address';
import Claim from './models/Claim';
import Contact from './models/Contact';
import FNOLAdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage';
import FNOLAdditonalLossdetailsPage from './pages/AdditionalLossdetails/AdditionalLossdetailsPage';
import ClaimsConfirmationPage from './pages/ConfirmationPage/ConfirmationPage';
import FNOLContactDetailsPage from './pages/ContactDetails/ContactDetailsPage';
import FNOLSelectPolicy from './pages/FNOLSelectPolicy/FNOLSelectPolicy';
import FNOLSummaryPage from './pages/Summary/SummaryPage';
import FNOLTypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
import FNOLWherePage from './pages/Where/WherePage';
import LossDetailsPage from './pages/LossDetails/LossDetailsPage'
import ClaimUtil from './utils/ClaimUtil';

setComponentMapOverrides(
    {
        BaseFNOLWizard: { component: 'BaseFNOLWizard' },
        FNOLSelectPolicy: { component: 'FNOLSelectPolicy' },
        FNOLSummaryPage: { component: 'FNOLSummaryPage' },
        LossDetailsPage: { component: 'LossDetailsPage'},
        FNOLContactDetailsPage: { component: 'FNOLContactDetailsPage' },
        FNOLTypeOfIncidentPage: { component: 'FNOLTypeOfIncidentPage' },
        FNOLWherePage: { component: 'FNOLWherePage' },
        FNOLAdditonalLossdetailsPage: {
            component: 'FNOLAdditonalLossdetailsPage'
        },
        FNOLAdditionalInformationPage: {
            component: 'FNOLAdditionalInformationPage',
        },
        ClaimsConfirmationPage: { component: 'ClaimsConfirmationPage' },
    },
    {
        BaseFNOLWizard,
        FNOLSelectPolicy,
        FNOLSummaryPage,
        FNOLContactDetailsPage,
        LossDetailsPage,
        FNOLTypeOfIncidentPage,
        FNOLWherePage,
        FNOLAdditonalLossdetailsPage,
        FNOLAdditionalInformationPage,
        ClaimsConfirmationPage,
    }
);

export { default as FNOLLossLocation } from './components/LossLocation/LossLocation';
export { default as fnolCommonMessages } from './FNOL.messages';
export {
    BaseFNOLWizard as default,
    Claim,
    ClaimsConfirmationPage,
    Contact,
    Address,
    ClaimUtil,
    VehicleDamagePicker,
};
